import {
  bulkUpdateBorrowersAction,
  createNonBorrowerEntityAction,
  editNonBorrowerEntitiesAction,
  getBorrowersInfoAction,
  getNonBorrowersDataAction,
} from 'store/loanApplications/actions';

import { ENTITY_TYPE_HREF } from '../EditEntityModal.constants';

import {
  getBorrowerValuesToSend,
  getNBEValuesToSend,
  normalizeBorrowerApplicationData,
  normalizeNBEApplicationData,
} from './Content.utils';

export const REQUIRED_FIELDS_MESSAGE = 'All required fields must be completed.';

export const ENTITY_GET_DATA_ACTION_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: getBorrowersInfoAction,
  [ENTITY_TYPE_HREF.NON_BORROWER]: getNonBorrowersDataAction,
};

export const ENTITY_EDIT_DATA_ACTION_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: bulkUpdateBorrowersAction,
  [ENTITY_TYPE_HREF.NON_BORROWER]: editNonBorrowerEntitiesAction,
};

export const ENTITY_CREATE_DATA_ACTION_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: null,
  [ENTITY_TYPE_HREF.NON_BORROWER]: createNonBorrowerEntityAction,
};

export const NORMALIZE_ENTITY_GET_DATA_ACTION_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: normalizeBorrowerApplicationData,
  [ENTITY_TYPE_HREF.NON_BORROWER]: normalizeNBEApplicationData,
};

export const NORMALIZE_ENTITY_DATA_ACTION_CONFIG = {
  [ENTITY_TYPE_HREF.BORROWER]: getBorrowerValuesToSend,
  [ENTITY_TYPE_HREF.NON_BORROWER]: getNBEValuesToSend,
};
